import { IContainer, injectContainer } from '../../interface/container';

export interface IRequestSerialized {
    headers: any;
    url: string;
    method: string;
    mode: RequestMode | undefined;
    credentials: RequestCredentials | undefined;
    cache: RequestCache;
    redirect: RequestRedirect | undefined;
    referrer: string;
    referrerPolicy: ReferrerPolicy;
    isHistoryNavigation: boolean;
    isReloadNavigation: boolean;
    integrity: string;
    destination: string;
    body: string;
}

export interface IRequestSerializer {
    serialize: (request: Request) => Promise<IRequestSerialized>;
    parse: (request: IRequestSerialized) => Request;
}

const TYPES = {
    IRequestSerializer: Symbol.for('IRequestSerializer'),
};

export function injectRequestSerializer(
    container: IContainer = injectContainer(),
): IRequestSerializer {
    return container.get<IRequestSerializer>(TYPES.IRequestSerializer);
}

export function bindRequestSerializer(
    val: IRequestSerializer,
    container: IContainer = injectContainer(),
) {
    return container.bind<IRequestSerializer>(TYPES.IRequestSerializer, val);
}

export function unbindRequestSerializer(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IRequestSerializer);
}
